module.exports = "mutation saveProduct($product:ProductInput!){saveProduct(product:$product)}"